<template>
  <v-card height="auto" elevation="0">
    <v-container>
      <v-row>
        <v-col lg="12" md="12" sm="12" xs="12">
          <v-card align="center" elevation="0">
            <v-card class="image1" elevation="0">
              <a
                href="https://www.youtube.com/channel/UC9moS5ctZRw6C8K0zGIv8mQ"
                target="_blank"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/YouTube_Logo_%282013-2017%29.svg/2560px-YouTube_Logo_%282013-2017%29.svg.png"
                />
              </a>
            </v-card>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="12" md="12" sm="12" xs="12" dense>
          <v-card align="center" elevation="0">
            <v-card class="image2" elevation="0">
              <a
                href="https://open.spotify.com/show/7IsnZ5vCcZDnDmgNndiJtm?si=1dxepHMeTTOjTFrCwm9rbA&dl_branch=1"
                target="_blank"
              >
                <img
                  src="https://promocionmusical.es/wp-content/uploads/2020/12/spotify-ofertas-de-empleo.png"
                />
              </a>
            </v-card>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="12" md="12" sm="12" xs="12" dense>
          <v-card align="center" elevation="0">
            <v-card class="image3" elevation="0">
              <a
                href="https://podcasts.apple.com/mx/podcast/integrando-la-industria/id1552482537"
                target="_blank"
              >
                <img
                  src="https://www.tekcrispy.com/wp-content/uploads/2019/11/2019-11-23_20-40-34-640x226.png"
                />
              </a>
            </v-card>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="12" md="12" sm="12" xs="12" dense>
          <v-card align="center" elevation="0">
            <v-card class="image4" elevation="0">
              <a
                href="https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy80YjM0YmEwYy9wb2RjYXN0L3Jzcw/episode/QnV6enNwcm91dC04NjI1MjM5?sa=X&ved=0CAUQkfYCahcKEwjon7a1vYjxAhUAAAAAHQAAAAAQAQ"
                target="_blank"
              >
                <img
                  src="https://www.trecebits.com/wp-content/uploads/2020/03/Google-Podcasts-logo-1-800x445.jpg"
                />
              </a>
            </v-card>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="12" md="12" sm="12" xs="12" dense>
          <v-card align="center" elevation="0">
            <v-card class="image5" elevation="0">
              <a href="https://www.deezer.com/es/show/2273652" target="_blank">
                <img
                  src="https://cdn.smehost.net/sonymusiccommx-mxprod/wp-content/uploads/2019/08/deezer.png"
                />
              </a>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "child_ProductDetailBaner3",

  components: {},

  data() {
    return {
      title: "",
    };
  },

  props: {},

  methods: {},

  computed: {},

  watch: {},

  created() {},

  mounted() {},
};
</script>

<style>
.image1 img {
  width: 70px;
  height: 45px;
}

.image2 img {
  width: 110px;
  height: 60px;
}

.image3 img {
  width: 130px;
  height: 40px;
}

.image4 img {
  width: 160px;
  height: 80px;
}

.image5 img {
  width: 90px;
  height: 55px;
}
</style>
